import request from './request'
import store from '../store'

// 农事通大屏-社会化统计总数 store.getters.getactiveRegionObj.areaCode;
export function getTotalStatistics(params) {
  return request.get("../farming/largeScreen/totalStatistics", {...params, areaCode : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 农事通大屏-农活热点区域排行
export function getWorkAreaRank (params) {
  return request.get('../farming/largeScreen/workAreaRank', {...params, areaCode : store.getters.getactiveRegionObj.areaCode}).then(res => res);
}

// 车辆租赁和二手交易
export function getUsedMachinery (params) {
  return request.get('../farming/largeScreen/usedMachinery', {...params, areaCode : store.getters.getactiveRegionObj.areaCode}).then(res => res);
}

//  农事通大屏-热门农机
export function getPopularVehicle (params) {
  return request.get('../farming/largeScreen/popularVehicle', {...params, areaCode : store.getters.getactiveRegionObj.areaCode}).then(res => res);
}

// 农事通大屏-热门农产品
export function getPopularProduct (params) {
  return request.get('../farming/largeScreen/popularProduct', {...params, areaCode : store.getters.getactiveRegionObj.areaCode}).then(res => res);
}

// 农事通大屏-热门农资
export function getPopularMaterial (params) {
  return request.get('../farming/largeScreen/popularMaterial', {...params, areaCode : store.getters.getactiveRegionObj.areaCode}).then(res => res);
}

// 农事通大屏-获取农技推广视频列表
export function getVideoList (params) {
  return request.get('../farming/largeScreen/video', {...params, areaCode : store.getters.getactiveRegionObj.areaCode}).then(res => res);
}

// 农事通大屏-获取农技知识列表
export function getPreachList (params) {
  return request.get('../farming/largeScreen/preach', {...params, areaCode : store.getters.getactiveRegionObj.areaCode}).then(res => res);
}

// 农事通大屏-获取店铺数量列表
export function getShopCount (params) {
  return request.get('../farming/largeScreen/stationNumsByArea', {...params, areaCode : store.getters.getactiveRegionObj.areaCode}).then(res => res);
}

// 农事通大屏-机手画像-年龄
export function getAgeProfile (params) {
  return request.get('../farming/largeScreen/ageProfile', {...params, areaCode : store.getters.getactiveRegionObj.areaCode}).then(res => res);
}

// 农事通大屏-机手画像-驾龄
export function getDriveYearProfile (params) {
  return request.get('../farming/largeScreen/driveYearProfile', {...params, areaCode : store.getters.getactiveRegionObj.areaCode}).then(res => res);
}

// 农事通大屏-地图数据-聚合数据
export function getMapStatistics (params) {
  return request.get('../farming/largeScreen/mapStatistics', {...params, areaCode : store.getters.getactiveRegionObj.areaCode}).then(res => res);
}

// 农事通大屏-地图数据-聚合数据
export function getStationListByRadius (params) {
  return request.get('../farming/largeScreen/mapPoints', {...params, areaCode : store.getters.getactiveRegionObj.areaCode}).then(res => res);
}
